import { dayjsWithTimezone } from '@healthhub/react-ui';

import type {
  Appointment,
  SupportingInformation,
} from '@shared/services/appointment/getLists/types/getAppointmentList.type';
import { SupportingInfoType } from '@shared/services/appointment/getLists/types/getAppointmentList.type';
import { GroupCode } from '@shared/utils/constants';

import { NOW_STATUSES, PAST_STATUSES } from '@features/Appointment/MobileRegistration/constants/mobileRegistration';
import { JourneyStatus } from '@features/Appointment/types/appointment.types';

import { SOURCE_SYSTEM, TODAY } from '../constants';

const getOrgIdWithSupportingInfoType = (supportingInfo: SupportingInformation[]): string | undefined =>
  supportingInfo?.find((info) => info.Type === SupportingInfoType.Organization)?.Id;

export function getTodayAppointmentOrganizationIds(appointmentsFiltered?: Appointment[]) {
  if (appointmentsFiltered) {
    const todayAppointmentOrgIds: string[] = [];
    appointmentsFiltered.forEach((appointment) => {
      if (dayjsWithTimezone(appointment.Start).isSame(TODAY, 'day')) {
        if (
          (appointment.SourceSystem === SOURCE_SYSTEM.NGEMR && appointment.GroupCode !== GroupCode.Polyclinic) ||
          appointment.SourceSystem === SOURCE_SYSTEM.OAS ||
          appointment.IsCeqmsPoly
        ) {
          const orgId = getOrgIdWithSupportingInfoType(appointment.SupportingInfo);
          if (orgId) todayAppointmentOrgIds.push(orgId);
        }
      }
    });
    return todayAppointmentOrgIds.join(',');
  }
  return '';
}

export const getJourneyStatus = (stationStatus) => {
  if (NOW_STATUSES.includes(stationStatus)) {
    return JourneyStatus.Current;
  }

  if (PAST_STATUSES.includes(stationStatus)) {
    return JourneyStatus.Past;
  }

  return JourneyStatus.Future;
};
